import React from 'react';
import PropTypes from 'prop-types';
import CopyArea from './CopyArea';
import QRCodeWidget from './QRCodeWidget';
import css from './CopyAreaWithQRCode.css';

function CopyAreaWithQRCode({
    containerStyle = {},
    type = null,
    label = '',
    copyText = '',
    copiedText = '',
    content = '',
    qrCodeLabel = '',
    qrCodeSize = 100,
    logoSrc = '',
}) {
    return (
        <div className={`${css.container} ${css[type]}`} style={containerStyle}>
            <div className={css.copyAreaWithQRCodeContainer}>
                <div className={css.copyAreaContainer}>
                    <CopyArea
                        containerStyle={containerStyle}
                        type={type}
                        label={label}
                        copyText={copyText}
                        copiedText={copiedText}
                        content={content}
                    />
                </div>
                <QRCodeWidget label={qrCodeLabel} size={qrCodeSize} value={content} defaultLogoSrc={logoSrc} />
            </div>
        </div>
    );
}

CopyAreaWithQRCode.propTypes = {
    containerStyle: PropTypes.objectOf(PropTypes.any),
    type: PropTypes.oneOf(['small', 'large', null]),
    label: PropTypes.string,
    copyText: PropTypes.string,
    copiedText: PropTypes.string,
    content: PropTypes.string,
    qrCodeLabel: PropTypes.string,
    qrCodeSize: PropTypes.number,
    onCopyClicked: PropTypes.func,
    logoSrc: PropTypes.string,
};

export default CopyAreaWithQRCode;
